import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Slider from 'react-slick';
import { Container } from 'reactstrap';

import deepak from './img/team/8b1b68ce.png';
import shekhar from './img/team/4b99387b.png';
import arpit from './img/team/f1f8c8a7.png';
import yash from './img/team/f660ac03.png';
import gautam from './img/team/6403252b.jpeg';
// import abhash from './img/team/babbb2b4.png';
// import maniprakash from './img/team/16338d7e.png';


const sliderSettings = {
  dots: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const teamData = [
  {
    name: 'Deepak Singh',
    title: 'Co-founder and CEO',
    thumbnail: deepak,
    link: 'https://www.linkedin.com/in/deepaksinghkgp/',
  },
  {
    name: 'Arpit Goyal',
    title: 'Co-founder and CTO',
    thumbnail: arpit,
    link: 'https://www.linkedin.com/in/arpitgoyalkgp/',
  },
  {
    name: 'Yash Pal Mittal',
    title: 'Co-founder and Machine Learning Head',
    thumbnail: yash,
    link: 'https://www.linkedin.com/in/yash-pal-mittal-7347945b/',
  },
  {
    name: 'Shekhar Suman',
    title: 'Co-founder and COO',
    thumbnail: shekhar,
    link: 'https://www.linkedin.com/in/shekharsumankgp/',
  },
  {
    name: 'Gautam Boyanapally',
    title: 'Head - Business Development',
    thumbnail: gautam,
    link: 'https://www.linkedin.com/in/gautam-boyanapally-6403252b/',
  },
];

class Team extends React.Component {
  static propTypes = {
    styles: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      sliderKey: 'initial',
    };
  }

  componentDidMount() {
    // this.forceUpdate();
    // console.log(this.slider);
    // this.slider.forceUpdate();
    this.setState({ sliderKey: 'final' });
  }

  render() {
    const {
      styles: s,
    } = this.props;

    const {
      sliderKey
    } = this.state;

    return (
      <div id="team">
        <section className={cx(s.fizTeamArea, s.fizTeamAreaTwo, s.bgColorThree)}>
          <Container>
            <div className={cx(s.sectionTitleThree, s.titleGr, s.mb60)}>
              <h2><span>Management</span>Team</h2>
            </div>
            <div>
              <Slider {...sliderSettings} key={sliderKey}>
                {
                  teamData.map(user => (
                    <div className={s.teamThumbnail} key={user.name}>
                      <div className={s.thumbnailRoundImg}>
                        <img src={user.thumbnail} alt="" />
                      </div>
                      <h4>{user.name}</h4>
                      <h6>{user.title}<br /><br /></h6>
                      <hr />
                      <div className={s.callLink}>
                        <div className={s.linkGroup}>
                          <i className={s.iconMail} />
                          <a className={s.linkBlack} href={user.link} target="_blank" rel="noreferrer">LinkedIn Profile</a>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </Slider>
            </div>
          </Container>
        </section>
      </div>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/routes/home/Team.js